import { createLucideIcon } from 'lucide-react';
export const SortIcon = createLucideIcon('', [
  [
    'path',
    {
      d: 'M17 21V4.25',
      key: '1qi20e',
    },
  ],
  [
    'path',
    {
      d: 'M20.5 7.25L17 4.25L13.5 7.25',
      key: '1l6zmb',
    },
  ],
  [
    'path',
    {
      d: 'M4.5 6.25C5.235 6.25 6.11066 5.88959 6.41066 5.45459C6.70316 5.01959 6.82961 4.58447 6.82961 4.58447L7 4H7.75002V10.5',
      key: '1aeiq9',
    },
  ],
  [
    'path',
    {
      d: 'M5 15.5V15C5 13.56 6.06 13 7.5 13C8.94 13 10 13.56 10 15C10 16.005 9.765 16.5275 9 17C8.175 17.51 7.0475 17.715 6.5 18L5.5 18.5C5.5 18.5 5 18.815 5 19.25V20H8H11',
      key: '1nl1r3',
    },
  ],
]);
